// for add employee

export const RESET_DELETE_USER = "reset_delete_user";
export const DELETE_USER = "delete_user";
export const DELETE_USER_SUCCESS = "delete_user_success";
export const DELETE_USER_FAILURE = "delete_user_failure";
